import React, { useCallback, useEffect, useRef, useState } from "react";
import { MdSearch } from "react-icons/md";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
// import FileUploadOngoingSales from "./FileUploadOngoingSales";
import ShowTaskDetails from "./ShowTaskDetails";
import { fetchEmployees } from "./../../../../../store/slices/employeeSlice";
import {
  fetchWorkEntries,
  fetchWorkEntriesProjectTracking,
} from "../../../../../store/slices/workentriesSlice";
import {
  fetchDescriptionTasks,
  fetchDescriptionTasksProjectTracking,
} from "../../../../../store/slices/DescriptionTask";
import {
  fetchHardwareDescriptions,
  fetchHardwareProjectTracking,
} from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileUploadSales from "../ResponseReceived/FileUploadSales";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { updateAllProjectDueDatesByQuotationId } from "../../../../../store/slices/projectDueDateSlice";
import { fetchLeads, updateLead } from "../../../../../store/slices/leadsSlice";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { setLeadReadTrue } from "../../../../../store/slices/readSlice";
import DateConversion from "../../../../../utils/DateConversion";
import { setAutoExpandAllTaskDetails, setSelectedProjectName } from "../../../../../store/slices/ProjectOngoing/taskScrollSlice";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";
import {
  getLoggedSalesUserId,
  resolveEntityId,
} from "../../../../../utils/salespersonRatesScope";
import useToolGuideSync from "../../../../../features/toolGuide/useToolGuideSync";
import { BUCKET_KEYS } from "../../../../../features/toolGuide/toolGuideConfig";

const ProjectOngoingSales = ({ ongoingSalesProject, handlerefresh, isViewOnly = false }) => {
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } =
    DateConversion();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { syncToolGuideStep } = useToolGuideSync(BUCKET_KEYS.PROJECT_ONGOING);
  const { employees } = useSelector((state) => state.employees);
  const { projects, authLevel, loggedInUserId } = useSelector(
    (state) => state.projects
  );
  const { group: masterGroups } = useSelector((state) => state.group);
  const { leads } = useSelector((state) => state.leads);
  const { entries } = useSelector((state) => state.workentries);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );
  const selectedProjectName = useSelector(
    (state) => state.taskScroll.selectedProjectName
  );
  const selectedTaskId = useSelector(
    (state) => state.taskScroll.selectedTaskId
  );
  const autoExpandAllTaskDetails = useSelector(
    (state) => state.taskScroll.autoExpandAllTaskDetails
  );
  console.log("selectedTaskId selectedProjectName", selectedProjectName);
  console.log("selectedTaskId selectedTaskId", selectedTaskId);

  useEffect(() => {
    dispatch(fetchLeads());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());

    dispatch(fetchWorkEntries());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchEmployees());
    dispatch(fetchAllProjects());
    dispatch(fetchGroups());
    dispatch(getMyTrainings());
  }, [dispatch]);

  const [currentProject, setCurrentProject] = useState(null);
  const [showAttach, setShowAttach] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowName, setRowName] = useState(null);
  const [showListState, setShowListState] = useState("tasktable");
  const [openInputReceived, setOpenInputReceived] = useState(null);
  const [selected, setSelected] = useState(false);
  const responseongoingref = useRef(null);

  useEffect(() => {
    if (rowName) {
      // Scroll to the right end of the container
      const scrollToPosition = responseongoingref.current.scrollWidth;
      responseongoingref.current.scrollTo({
        left: scrollToPosition,
        behavior: "smooth",
      });
    }
  }, [rowName]);
  const dropdownRefOpenInput = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openInputReceived !== null &&
        dropdownRefOpenInput.current[openInputReceived] &&
        !dropdownRefOpenInput.current[openInputReceived].contains(event.target)
      ) {
        setOpenInputReceived(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openInputReceived]);

  const [sortedProjects, setSortedProjects] = useState([]);
  const resolveId = useCallback((value) => {
    if (!value) return "";
    if (typeof value === "string" || typeof value === "number") {
      return String(value).trim();
    }
    return String(value?._id || value?.id || "").trim();
  }, []);

  const getGroupDisplayName = useCallback((row) => {
    const groupId =
      resolveId(row?.projectdata?.groupid) ||
      resolveId(row?.groupid) ||
      resolveId(row?.lead?.groupid);

    if (!groupId) return "";

    const matchedGroup = (masterGroups || []).find(
      (group) => resolveId(group?._id) === groupId
    );

    return (
      matchedGroup?.newGroupName ||
      matchedGroup?.GroupName ||
      matchedGroup?.groupName ||
      matchedGroup?.name ||
      ""
    );
  }, [masterGroups, resolveId]);

  const getRowSelectionKey = useCallback((row) => {
    if (!row) return "";
    if (row.quotationId != null && String(row.quotationId).trim() !== "") {
      return `q:${String(row.quotationId).trim()}`;
    }
    const groupName = getGroupDisplayName(row);
    return `pg:${String(row.ProjectName || "").trim().toLowerCase()}||${String(
      groupName
    )
      .trim()
      .toLowerCase()}`;
  }, [getGroupDisplayName]);

  const isRowMatchedBySelection = useCallback((row, selection) => {
    const selected = String(selection || "");
    if (!selected) return false;

    if (selected.startsWith("q:")) {
      const selectedQuotationId = selected.slice(2);
      return (
        row?.quotationId != null &&
        String(row.quotationId).trim() === selectedQuotationId
      );
    }

    if (selected.startsWith("pg:")) {
      return getRowSelectionKey(row) === selected;
    }

    // Backwards compatibility with older selection values.
    return (
      (row?.quotationId != null && String(row.quotationId) === selected) ||
      row?.ProjectName?.toLowerCase() === selected?.toLowerCase()
    );
  }, [getRowSelectionKey]);

  useEffect(() => {
    setSortedProjects(ongoingSalesProject);
  }, [ongoingSalesProject]);

  const itemsPerPage = 10; // or any number of rows you want per page
  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query);
  };

  const totalItems = sortedProjects.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects.slice(startIdx, endIdx);
  console.log("paginatedProjects sales ongoing", paginatedProjects);
  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = ongoingSalesProject.filter((LeadReport) =>
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value); // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }
        if (key === "AssignedGroup" || key === "groupid") {
          const groupName = getGroupDisplayName(LeadReport).toLowerCase();
          return groupName.includes(lowerCaseQuery);
        }

        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getGroupDisplayName(a), getGroupDisplayName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getGroupDisplayName(b), getGroupDisplayName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // Default to original filtered order
        sorted = [...sortedProjects];
        break;
    }

    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const [localDueDates, setLocalDueDates] = useState({});

  const handleDueDateChange = async (date, projectName, quotationId) => {
    if (isViewOnly) return;
    if (!date || !projectName) return;
    const rowKey = quotationId || projectName;

    setLocalDueDates((prev) => ({ ...prev, [rowKey]: date }));

    try {
      await dispatch(
        updateAllProjectDueDatesByQuotationId({
          quotationId: quotationId || projectName,
          ProjectDueDate: date,
        })
      );
      updateLeadDueDate(projectName, quotationId, date);
    } finally {
      dispatch(fetchAllProjects());
      setTimeout(() => {
        setLocalDueDates((prev) => {
          const copy = { ...prev };
          delete copy[rowKey];
          return copy;
        });
      }, 200);
    }
  };

  const updateLeadDueDate = async (projectName, quotationId, date) => {
    const matchedLead = leads.find((lead) =>
      (quotationId != null && lead.quotationId != null)
        ? String(lead.quotationId) === String(quotationId)
        : lead?.ProjectName === projectName
    );
    if (!matchedLead) return;
    try {
      const updatedLeadData = {
        DateDue: date,
        // FollowupDate: date,
        ProjectName: projectName,
      };
      await dispatch(
        updateLead({ id: matchedLead.id, updatedData: updatedLeadData })
      ).unwrap();

      dispatch(fetchLeads());
    } catch (error) {
      console.error("Error updating Notes:", error);
    }
  };

  const handleleadread = async (row) => {
    if (isViewOnly) return;
    const matchedLead = leads.find((lead) =>
      (row.quotationId != null && lead.quotationId != null)
        ? String(lead.quotationId) === String(row.quotationId)
        : lead?.ProjectName === row.ProjectName
    );
    if (!matchedLead) return;
    if (matchedLead.isRead === false) {
      const quotationId = matchedLead.quotationId;
      try {
        if (quotationId) await dispatch(setLeadReadTrue(quotationId));
      } catch (error) {
        console.error("Error updating Notes:", error);
      } finally {
        handlerefresh();
      }
    }
  };

  useEffect(() => {
    if (!selectedProjectName || !sortedProjects) return;

    const globalIndex = sortedProjects.findIndex((p) =>
      isRowMatchedBySelection(p, selectedProjectName)
    );

    if (globalIndex === -1) return;

    // Calculate page number where that project exists
    const pageNumber = Math.floor(globalIndex / itemsPerPage) + 1;

    // Change the page first
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
    }
  }, [selectedProjectName, currentPage, sortedProjects, isRowMatchedBySelection]);

  const refs = useRef({}); // store refs by task id

  useEffect(() => {
    if (!selectedProjectName || paginatedProjects.length === 0) return;
    const proj = paginatedProjects.find((p) =>
      isRowMatchedBySelection(p, selectedProjectName)
    );
    const refKey = proj?.quotationId ?? proj?.ProjectName;
    if (refKey && refs.current[refKey]) {
      setTimeout(() => {
        if (refs.current[refKey]) {
          refs.current[refKey].scrollIntoView({ behavior: "smooth", block: "center" });
        }
        dispatch(setSelectedProjectName(null));
      }, 50);
    }
  }, [selectedProjectName, paginatedProjects, dispatch, isRowMatchedBySelection]);

  useEffect(() => {
    if (selectedProjectName) {
      const ProjectToScroll = paginatedProjects?.find((proj) =>
        isRowMatchedBySelection(proj, selectedProjectName)
      );
      setRowName(ProjectToScroll?.quotationId ?? ProjectToScroll?.ProjectName);
      setShowListState("tasktable");
    }
  }, [selectedProjectName, paginatedProjects, isRowMatchedBySelection]);

  // Track completion toasts across bucket remounts (localStorage + ref).
  const notifiedProjectsRef = useRef(new Set());
  const hasHydratedNotifiedRef = useRef(false);

  // Only one toast: the latest manager-completed lead waiting for sales approval.
  useEffect(() => {
    if (!ongoingSalesProject?.length || !projects?.length) return;

    const email = localStorage.getItem("email") || "anon";
    const storageKey = `po_sales_completion_notified_${email}`;

    const loadNotifiedKeys = () => {
      try {
        const raw = localStorage.getItem(storageKey);
        const parsed = raw ? JSON.parse(raw) : [];
        return new Set(Array.isArray(parsed) ? parsed : []);
      } catch {
        return new Set();
      }
    };

    const saveNotifiedKeys = (set) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify([...set]));
      } catch {
        // ignore quota / private mode
      }
    };

    if (!hasHydratedNotifiedRef.current) {
      notifiedProjectsRef.current = loadNotifiedKeys();
      hasHydratedNotifiedRef.current = true;
    }

    const loggedUserId = getLoggedSalesUserId(
      loggedInUserId,
      employees,
      email === "anon" ? null : email
    );

    const getProjectKey = (row) =>
      row.quotationId != null && String(row.quotationId).trim() !== ""
        ? `completed_${row.quotationId}`
        : `completed_${row.ProjectName}`;

    const getRecencyTs = (row, matchedProjects) => {
      const candidates = [
        row?.updatedAt,
        row?.DateRequested,
        row?.LeadDate,
        row?.createdAt,
        ...(matchedProjects || []).flatMap((p) => [
          p?.updatedAt,
          p?.DateRequested,
          p?.createdAt,
        ]),
      ];
      let max = 0;
      candidates.forEach((v) => {
        const t = new Date(v).getTime();
        if (Number.isFinite(t) && t > max) max = t;
      });
      return max;
    };

    const completedRows = [];

    ongoingSalesProject.forEach((row) => {
      if (authLevel === "L3") {
        const rowProjects = row.Projects?.length ? row.Projects : [row];
        const isOwnedByLoggedUser = rowProjects.some(
          (project) => resolveEntityId(project.createdBy) === loggedUserId
        );
        if (!loggedUserId || !isOwnedByLoggedUser) {
          return;
        }
      }

      const matchedProjects = projects.filter((proj) =>
        row.quotationId != null && proj.quotationId != null
          ? String(proj.quotationId) === String(row.quotationId)
          : proj.ProjectName === row.ProjectName
      );

      const allProjectsCompleted = matchedProjects.every((project) => {
        if (!project?.Assignedperson || project.Assignedperson.length === 0) {
          return false;
        }
        return project.Assignedperson.every(
          (person) => person?.isProjectComplete === true
        );
      });

      const projectKey = getProjectKey(row);

      if (allProjectsCompleted) {
        completedRows.push({
          row,
          projectKey,
          matchedProjects,
          recency: getRecencyTs(row, matchedProjects),
        });
      } else if (notifiedProjectsRef.current.has(projectKey)) {
        // Reverted completion → allow a future toast if it completes again
        notifiedProjectsRef.current.delete(projectKey);
        saveNotifiedKeys(notifiedProjectsRef.current);
      }
    });

    if (completedRows.length === 0) return;

    // Newest completion first
    completedRows.sort((a, b) => b.recency - a.recency);

    const unseen = completedRows.filter(
      (item) => !notifiedProjectsRef.current.has(item.projectKey)
    );
    if (unseen.length === 0) return;

    const latest = unseen[0];

    enqueueSnackbar(
      `Project "${latest.row.ProjectName}" completion by the manager and waiting for your approval`,
      {
        variant: "info",
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        autoHideDuration: 5000,
      }
    );

    // Mark every currently-completed row as seen so older ones never spam on reopen.
    completedRows.forEach((item) => {
      notifiedProjectsRef.current.add(item.projectKey);
    });
    saveNotifiedKeys(notifiedProjectsRef.current);
  }, [
    ongoingSalesProject,
    projects,
    enqueueSnackbar,
    authLevel,
    loggedInUserId,
    employees,
  ]);

  return (
    <div>
      <>
        {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
        <div className="pt-2">
          <div className="bg-white rounded-t flex justify-between items-center p-2">
            <div className=" font-semibold ">
              <h3>Project Ongoing</h3>
            </div>

            <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
              <MdSearch className=" w-5 h-5 text-gray-500" />
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchInputChange}
                placeholder="Search"
                className="bg-[#e0e7ff] outline-none w-[80%]"
              />
            </div>
          </div>
          <div
            ref={responseongoingref}
            className="w-full  bg-white  h-full  min-h-[20vh] max-h-[90vh] overflow-auto pb-5 "
          >
            <div className={`w-full ${rowName ? "min-w-full" : ""}`}>
              <div className="sticky top-0 left-0 bg-[#e8e8e8] z-[1299] font-semibold w-full min-w-full">
                <div className="flex w-full min-w-full h-full bg-[#e8e8e8] text-xs text-center">
                  <div className={`${rowName ? "w-[42%] flex-shrink-0" : "w-[80%]"} flex`}>
                    <div className={`${rowName ? "w-[10%]" : "w-14"} border flex justify-center items-center`}>
                      Sr. No
                    </div>
                    <div
                      className={` ${
                        rowName ? "w-[18%]" : "w-[20%] h-12"
                      } relative  border p-2 break-words text-wrap flex justify-start items-center align-middle `}
                    >
                      Group
                      <div className="flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("AssignedGroup", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("AssignedGroup", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={` ${
                        rowName ? "w-[18%]" : "w-[20%] h-12"
                      } relative border p-2 break-words text-wrap flex justify-start items-center align-middle `}
                    >
                      Project
                      <div className="flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("ProjectName", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("ProjectName", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={` ${
                        rowName ? "w-[20%]" : "w-[20%] h-12"
                      } relative border p-2 break-words text-wrap flex justify-center items-center align-middle `}
                    >
                      Date Requested{" "}
                      <div className="flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("DateRequested", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("DateRequested", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={` ${
                        rowName ? "w-[18%]" : "w-[20%] h-12"
                      } relative border p-2 break-words text-wrap flex justify-center items-center align-middle `}
                    >
                      Due Date
                      <div className=" flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("ProjectDueDate", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("ProjectDueDate", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        rowName ? "w-[16%]" : "w-[20%] h-12"
                      } border p-2 break-words text-wrap flex justify-center items-center `}
                    >
                      Attachment
                    </div>
                  </div>
                  {rowName ? (
                    <div className="flex w-[58%] min-w-0 bg-[#e8e8e8]">
                      <div className="w-[22%] bg-[#e8e8e8] border p-2 break-words text-wrap flex justify-start items-center">
                        Manager Details
                      </div>
                      <div className="w-[50%] flex flex-col bg-[#e8e8e8] border break-words text-wrap">
                        <div className="w-full h-[50%] break-words text-wrap flex justify-center items-center">
                          Task Details
                        </div>
                        <div className="w-full h-[50%] border break-words text-wrap flex ">
                          <div
                            onClick={() => setShowListState("tasktable")}
                            className={`w-[50%]  ${
                              showListState === "tasktable"
                                ? "bg-blue-500 text-white"
                                : ""
                            } p-2 cursor-pointer flex justify-center items-center`}
                          >
                            Effort Expenses
                          </div>
                          <div
                            onClick={() => setShowListState("otherexpenses")}
                            className={` w-[50%] ${
                              showListState === "otherexpenses"
                                ? "bg-blue-500 text-white"
                                : ""
                            } p-2 cursor-pointer flex justify-center items-center`}
                          >
                            {/* className="w-[50%] flex justify-center items-center"> */}
                            Other Expenses
                          </div>
                        </div>
                      </div>
                      <div className="w-[28%] bg-[#e8e8e8] border p-2 break-words text-wrap flex justify-center items-center">
                        Tracker
                      </div>
                    </div>
                  ) : (
                    <div className="w-[20%] h-12 h-13 border flex justify-center items-center ">
                      <div className="w-full  flex justify-center items-center h-full">
                        Task Details
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full">
                {[...paginatedProjects]
                  .sort((a, b) => {
                    return Number(a.isRead) - Number(b.isRead);
                  })
                  .map((row, index) => {
                    const rowKey = row.quotationId ?? row.ProjectName;
                    return (
                      <div
                        className={`flex text-xs ${
                          row.isRead === false ? "font-bold" : " "
                        } w-full hover:bg-gray-100 cursor-pointer group `}
                        ref={(el) => (refs.current[rowKey] = el)}
                        key={rowKey ?? index}
                      >
                        <div className={`${rowName ? "w-[42%] flex-shrink-0" : "w-[80%]"} flex `}>
                          <div
                            onClick={() => {
                              syncToolGuideStep("view-details");
                              setRowName(
                                rowName === rowKey ? null : rowKey
                              );
                              setSelected(!selected);
                              handleleadread(row);
                            }}
                            className={`${rowName ? "w-[10%]" : "w-14"} p-2 group-hover:bg-gray-100 text-center border-b flex justify-start align-middle items-center `}
                          >
                            {startIdx + index + 1}
                          </div>
                          <div
                            onClick={() => {
                              syncToolGuideStep("view-details");
                              setRowName(
                                rowName === rowKey ? null : rowKey
                              );
                              setSelected(!selected);
                              handleleadread(row);
                            }}
                            className={` ${rowName ? "w-[18%]" : "w-[20%]"
                            } border-b group-hover:bg-gray-100 flex justify-start align-middle items-center  p-2 break-words text-wrap `}
                          >
                            {getGroupDisplayName(row)}
                          </div>
                          <div
                            onClick={() => {
                              setRowName(
                                rowName === rowKey ? null : rowKey
                              );
                              setSelected(!selected);
                              handleleadread(row);
                            }}
                            className={` ${rowName ? "w-[18%]" : "w-[20%]"
                            } border-b group-hover:bg-gray-100 flex justify-start align-middle items-center text-left p-2 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}
                          >
                            {row.ProjectName}
                          </div>
                          <div
                            onClick={() => {
                              setRowName(
                                rowName === rowKey ? null : rowKey
                              );
                              setSelected(!selected);
                              handleleadread(row);
                            }}
                            className={` ${rowName ? "w-[20%]" : "w-[20%]"
                            } border-b group-hover:bg-gray-100 flex justify-center align-middle items-center  p-2 break-words text-wrap `}
                          >
                            {row.DateRequested &&
                            !isNaN(new Date(row.DateRequested))
                              ? formatDateByCountry(row.DateRequested)
                              : ""}
                          </div>
                          <div
                            onClick={() => {}}
                            className={` ${
                              rowName ? "w-[18%]" : "w-[20%]"
                            } border-b group-hover:bg-gray-100 flex justify-center align-middle items-center p-2 break-words text-wrap `}
                          >
                            <DatePicker
                              selected={
                                (() => {
                                  if (localDueDates[rowKey]) {
                                    const date = localDueDates[rowKey];
                                    return date instanceof Date && !isNaN(date) ? date : null;
                                  }
                                  if (row.ProjectDueDate) {
                                    const date = new Date(row.ProjectDueDate);
                                    return date instanceof Date && !isNaN(date) ? date : null;
                                  }
                                  return null;
                                })()
                              }
                              // selected={row.ProjectDueDate ? new Date(row.ProjectDueDate) : null}
                              onChange={(date) =>
                                handleDueDateChange(date, row.ProjectName, row.quotationId)
                              }
                              dateFormat={getDateFormat()}
                              className={`w-full text-center outline-none border border-gray-300 p-2 group-hover:bg-gray-100 rounded-md bg-blue-50 ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                              placeholderText={getDatePlaceholder()}
                              popperClassName="z-[1500]"
                              minDate={new Date()}
                              disabled={isViewOnly}
                            />
                          </div>
                          <div
                            className={` ${
                              rowName ? "w-[16%]" : "w-[20%]"
                            } border-b group-hover:bg-gray-100 p-2 flex justify-center align-middle items-center text-center break-words text-wrap `}
                          >
                            <AttachFileIcon
                              className="rotate-12 cursor-pointer"
                              onClick={() => {
                                setCurrentProject(row);
                                setShowAttach(true);
                              }}
                            />
                          </div>
                        </div>

                        {rowName === rowKey ? (
                          <div
                            className={`w-[58%] min-w-0 flex group-hover:bg-gray-100 border-b`}
                          >
                            <>
                              <ShowTaskDetails
                                row={row}
                                index={index}
                                employees={employees}
                                projects={projects}
                                projectTrackingWorkEntries={
                                  projectTrackingWorkEntries
                                }
                                descriptionProjectTracking={
                                  descriptionProjectTracking
                                }
                                hardwareProjectTracking={
                                  hardwareProjectTracking
                                }
                                entries={entries}
                                tasks={tasks}
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                                showListState={showListState}
                                setShowListState={setShowListState}
                                setRowName={setRowName}
                                handlerefresh={handlerefresh}
                                selectedTaskId={selectedTaskId}
                                autoExpandAllTaskDetails={autoExpandAllTaskDetails}
                                onAutoExpandAllTaskDetailsConsumed={() => dispatch(setAutoExpandAllTaskDetails(false))}
                                isViewOnly={isViewOnly}
                              />
                            </>
                          </div>
                        ) : (
                          <div
                            onClick={() => {
                              setRowName(
                                rowName === rowKey ? null : rowKey
                              );
                              setSelected(!selected);
                              handleleadread(row);
                            }}
                            className={`${
                              rowName ? "w-[58%] min-w-0" : "w-[20%]"
                            }  group-hover:bg-gray-100 cursor-pointer border-b flex justify-center items-center`}
                          >
                            {rowName ? (
                              <div className="flex w-full">
                                <div className="w-[22%] p-2 flex justify-center items-center"></div>
                                <div className="w-[50%] p-2 flex justify-center items-center">
                                  Multiple
                                </div>
                                <div className="w-[28%] p-2 flex justify-center items-center"></div>
                              </div>
                            ) : (
                              <div className="w-full  p-2 flex justify-center items-center">
                                Multiple
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                {paginatedProjects.length === 0 && (
                  <div className="noDataAvailable p-2">No Result Found</div>
                )}
              </div>
            </div>
          </div>

          <div
            className={`pagination flex justify-between  text-xs items-center bg-white pb-2 pl-2 rounded-md ${
              paginatedProjects.length > 0 ? "p-1" : ""
            } `}
          >
            <div>
              {totalItems > 0 ? (
                <>
                  Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                  {totalItems} Entries
                </>
              ) : (
                <>
                  {paginatedProjects.length > 0 && (
                    <>Showing {paginatedProjects.length} Entries</>
                  )}
                </>
              )}
            </div>

            {totalPages > 1 && (
              <div className="flex">
                <button
                  onClick={() => setCurrentPage(1)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === 1}
                  title="First Page"
                >
                  <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                </button>
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === 1}
                >
                  <ChevronRightIcon className="w-5 h-5 rotate-180" />
                </button>

                {Array.from({ length: 3 }, (_, index) => {
                  const pageNumber = currentPage - 1 + index;
                  if (pageNumber >= 1 && pageNumber <= totalPages) {
                    return (
                      <button
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        className={`px-4 py-2 mx-2 border rounded ${
                          currentPage === pageNumber ? "bg-gray-300" : ""
                        }`}
                      >
                        {pageNumber}
                      </button>
                    );
                  }
                  return null;
                })}

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === totalPages}
                >
                  <ChevronRightIcon className="w-5 h-5" />
                </button>

                <button
                  onClick={() => setCurrentPage(totalPages)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === totalPages}
                  title="Last Page"
                >
                  <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                </button>
              </div>
            )}
          </div>
        </div>
        {showAttach && (
          <FileUploadSales
            currentProject={currentProject}
            setShowAttach={setShowAttach}
            employees={employees}
            isViewOnly={isViewOnly}
          />
        )}
      </>
    </div>
  );
};

export default ProjectOngoingSales;
